export function ConsultingBadge({
  type,
  label,
  className,
}: {
  type: "best-fit" | "high-rec";
  label: string;
  className?: string;
}) {
  const styles =
    type === "best-fit" ? "bg-[#43946C] text-[#000000]" : "bg-[#FFAA72] text-[#000000]";
  return (
    <span className={`px-2 py-0.5 rounded text-sm font-normal ${styles} ${className || ""}`}>
      {label}
    </span>
  );
}
